

<mat-toolbar>
  <h4>ACCEPT/DENY</h4>
</mat-toolbar>
  <div class="row text-center guardian-content">
    <span>
      Please accept or deny the case.
    </span>
  </div>



<div class="row text-center guardian-buttons">

    <button [class.loading]="denyBtnLoader" [disabled]="acceptBtnLoader || denyBtnLoader" mat-raised-button color="warn"
    style="text-transform: uppercase" [style.textAlign]="!denyBtnLoader ? 'center': 'right'" (click)="actionButton('Deny')">
    <div class="spinner"></div>
    <span class="label">Deny</span>
  </button>

    <button [class.loading]="acceptBtnLoader" [disabled]="acceptBtnLoader || denyBtnLoader" mat-raised-button color="accent"
    style="text-transform: uppercase" [style.textAlign]="!acceptBtnLoader ? 'center': 'right'" (click)="actionButton('Accept')">
      <div class="spinner"></div>
      <span class="label">Accept</span>
    </button>
    
</div>




// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/guardian-confirmation-dialog/guardinan-confirmation-dialog.component.html